<template>
  <div v-if="user.firstname" class="flex items-center flex-wrap">
    <!-- <span class="bold topLabel caps col-12 my3 py2">{{ user.firstname }}, personnalisez votre {{ offer.detail.unit_sales || offer.detail.recurring ? 'commande' : 'séjour' }}</span> -->
    <span class="bold topLabel caps col-12 my3 py2">{{ user.firstname }}, personnalisez votre commande</span>
    <OfferInfo />

    <div class="col-12 my3 py3 flex justify-end items-center">
      <Button class="col-5" :action="confirmConfigure" text="Continuez" />
    </div>
  </div>
  <div v-else class="flex justify-center items-center p4">
    <div class="spinner"></div>
  </div>
</template>

<script setup>

import { computed } from 'vue';

import { useStore } from '@/store/index';

import OfferInfo from '../../components/configure/OfferInfo';
import Button from '../../components/elements/Button';

import { changeToPage, initializeCartItem } from '@/utils/logics';

const store = useStore();

const user = computed(() => store.state.user);
const product = computed(() => store.state.product);
const offer = computed(() => store.state.offerInfo);

const confirmConfigure = () => {
  initializeCartItem({
    offer: offer.value,
    product: product.value,
    callback: cartItem => {
      if (!cartItem || !cartItem.participants.length) {
        return changeToPage('AddParticipant');
      }
      changeToPage('Participants');
      return undefined;
    },
    resumeOrder: false,
    configure: true
  });
};

</script>

<style lang="scss" scoped>
  .topLabel {
    font-size: 1.5rem;
  }

  @media (max-width: 40rem){
    .topLabel {
      font-size: 1.25rem;
    }
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #09f;
    animation: spin 1s ease infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
